import script from "./GoodList.vue?vue&type=script&setup=true&lang=ts"
export * from "./GoodList.vue?vue&type=script&setup=true&lang=ts"

import "./GoodList.vue?vue&type=style&index=0&id=6b6bdfe2&scoped=true&lang=less"

import exportComponent from "/Users/neal/www/bonwey/qingtv-back-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b6bdfe2"]])

export default __exports__